export default __webpack_public_path__ + "static/media/right-img-1.c3e7d049.png";